
export const text="Giftofgodfragrances.com is a New Jersey-based online brand name fragrance retailer which was founded in 2016. Since then Giftofgodfragrances.com has delivered quality products, at competitive prices with outstanding customer service. Giftofgodfragrances.com is a New Jersey-based online brand name fragrance retailer which was founded in 2016. Since then Giftofgodfragrances.com has delivered quality products, at competitive prices with outstanding customer service. Giftofgodfragrances.com is a New Jersey-based online brand name fragrance retailer which was founded in 2016. Since then Giftofgodfragrances.com has delivered quality products, at competitive prices with outstanding customer service.";


export const faqs = [
  {
    id: 1,
    question: "Overview",
    answer: "Gift of God Fragrances offers premium, long-lasting perfumes designed to create a signature scent for every individual. Our collections combine exquisite ingredients with expert craftsmanship, ensuring a luxurious and unforgettable fragrance experience for every customer."
  },
  {
    id: 2,
    question: "Benefits of Buying Perfumes Online from Gift of God Fragrances",
    answer: "Shopping online at Gift of God Fragrances is convenient, safe, and fast. You get access to exclusive collections, authentic products, secure payment options, and doorstep delivery. Our detailed descriptions and customer reviews help you make confident choices effortlessly."
  },
  {
    id: 3,
    question: "Enjoy Special Offers & Discount At Gift of God Fragrances",
    answer: "We regularly offer special promotions, seasonal discounts, and loyalty rewards to give our customers extra value. By subscribing to our newsletter or following us on social media, you can stay updated on exclusive deals and limited-time offers."
  },
  {
    id: 4,
    question: "FAQ",
    answer: "Our FAQ section provides answers to common questions regarding products, shipping, returns, and online purchases. It helps customers understand our policies, services, and offers, making their shopping experience smooth, informed, and enjoyable."
  },
];
